import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"
import type { Grain, Point } from "../salesSeries"
import { AXIS_TICK, PointTooltip, actionMarkers, xAxisProps } from "./chartParts"

// Units that left (sold plus gifted) as one line, so the trend is easy to
// read. Dashed lines mark when past actions ran.
export default function MovementChart({ points, grain }: { points: Point[]; grain: Grain }) {
  const data = points.map((p) => ({ ...p, out: p.sold + p.gifted }))

  return (
    <ResponsiveContainer width="100%" height={220}>
      <LineChart data={data} margin={{ top: 24, right: grain === "month" ? 40 : 16, bottom: 0, left: 0 }}>
        <CartesianGrid stroke="var(--chart-grid)" vertical={false} />
        <XAxis {...xAxisProps(points, grain)} type="number" domain={[0, points.length - 1]} />
        <YAxis width={44} tick={AXIS_TICK} stroke="var(--chart-grid)" />
        <Tooltip
          content={<PointTooltip lines={(p: Point) => [`Units out: ${(p.sold + p.gifted).toLocaleString()}`]} />}
          cursor={{ stroke: "var(--chart-axis)", strokeWidth: 1 }}
        />
        {actionMarkers(points)}
        <Line
          dataKey="out"
          stroke="var(--series-1)"
          strokeWidth={2}
          dot={grain === "day" ? false : { r: 3, fill: "var(--series-1)", strokeWidth: 0 }}
          activeDot={{ r: 5, strokeWidth: 2, stroke: "var(--card)" }}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  )
}
